<template>
    <!-- The frameless layout: the sign-in screen. It paints NOTHING, so the page
         canvas the theme establishes on `body` (theme/theme.css) is what the
         card floats on — the same canvas the settings frame stands on, so the
         two screens are recognisably one product.

         The height is the DYNAMIC viewport: the static one is the viewport a
         mobile browser would have with its URL bar hidden, so on a phone the
         "centred" card sits below the middle and the page scrolls for no
         reason. -->
    <div class="flex items-center justify-center min-h-dvh p-4">
        <slot />
    </div>
</template>
